import { connect } from 'react-redux';

import ImportDesktopFile from '../../components/ImportDesktopFile';

export default connect()(ImportDesktopFile);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ImportDesktopFile/index.tsx